// Aliplayer SDK 动态加载工具（单例）
//
// 阿里云播放器 SDK 通过 CDN 动态加载，仅在需要播放阿里云 VOD 视频时引入，
// 避免影响原有 m3u8 视频的加载性能。
//
// 使用方式：
//   import { loadAliplayer } from '@/utils/aliplayerLoader'
//   const Aliplayer = await loadAliplayer()
//   const player = new Aliplayer({ id, vid, playauth, ... }, callback)

const ALIPLAYER_VERSION = '2.16.0'
const ALIPLAYER_CSS = 'https://g.alicdn.com/de/prismplayer/' + ALIPLAYER_VERSION + '/skins/default/aliplayer-min.css'
const ALIPLAYER_JS = 'https://g.alicdn.com/de/prismplayer/' + ALIPLAYER_VERSION + '/aliplayer-min.js'

let loaderPromise = null

export function loadAliplayer () {
    if (loaderPromise) return loaderPromise
    loaderPromise = new Promise((resolve, reject) => {
        if (window.Aliplayer) {
            resolve(window.Aliplayer)
            return
        }
        // 加载 CSS
        const link = document.createElement('link')
        link.rel = 'stylesheet'
        link.href = ALIPLAYER_CSS
        document.head.appendChild(link)
        // 加载 JS
        const script = document.createElement('script')
        script.src = ALIPLAYER_JS
        script.onload = () => {
            if (window.Aliplayer) {
                resolve(window.Aliplayer)
            } else {
                loaderPromise = null
                reject(new Error('Aliplayer SDK 加载失败'))
            }
        }
        script.onerror = () => {
            loaderPromise = null
            reject(new Error('Aliplayer SDK 加载失败，请检查网络'))
        }
        document.head.appendChild(script)
    })
    return loaderPromise
}
